import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { fmtData } from "@/components/excelVoce/format";
import { AZIONE_LABEL } from "./labels";

const CAMPI = ["data", "descrizione", "esecutore_nome", "quantita", "um", "prezzo_unitario", "importo", "ore", "costo_orario", "importo_ore", "documento", "note", "is_annullata"];

const Diff = ({ prima, dopo }) => {
  if (!prima || !dopo) return null;
  const ch = CAMPI.filter((k) => String(prima[k] ?? "") !== String(dopo[k] ?? ""));
  const rp = JSON.stringify(prima.ripartizioni || []) !== JSON.stringify(dopo.ripartizioni || []);
  if (!ch.length && !rp) return null;
  return (
    <ul className="mt-1 text-[11px] text-slate-500 space-y-0.5">
      {ch.map((k) => <li key={k}><b>{k}</b>: {String(prima[k] ?? "—")} → {String(dopo[k] ?? "—")}</li>)}
      {rp && <li><b>ripartizioni</b>: {(prima.ripartizioni || []).length} → {(dopo.ripartizioni || []).length} quote</li>}
    </ul>
  );
};

export const StoricoDialog = ({ regId, onOpenChange }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => { if (regId) api.get(`/registro-effettivo/${regId}/storico`).then((r) => setRows(r.data)); }, [regId]);
  return (
    <Dialog open={!!regId} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="storico-dialog">
        <DialogHeader><DialogTitle>Storico modifiche</DialogTitle></DialogHeader>
        {!rows ? <p className="text-sm text-slate-500">Caricamento…</p> : (
          <ul className="space-y-3">{rows.map((h) => (
            <li key={h.id} className="border-l-2 border-amber-400 pl-3" data-testid={`storico-row-${h.azione}`}>
              <div className="text-sm"><b>{AZIONE_LABEL[h.azione] || h.azione}</b> · {h.autore || "—"} · {fmtData(h.data)}</div>
              <Diff prima={h.prima} dopo={h.dopo} />
            </li>
          ))}</ul>
        )}
      </DialogContent>
    </Dialog>
  );
};
